'use strict'
document.querySelectorAll('.squeeze-box__item__trigger').forEach(function (e) {
  e.addEventListener('click', function () {
    const e = this.nextElementSibling

    if (e.clientHeight) {
      this.classList.remove('is-open')
      e.style.maxHeight = 0
    } else {
      this.classList.add('is-open')
      e.style.maxHeight = 'none'
    }
  })
})
